module.exports = __webpack_public_path__ + "static/media/team_icon_tree.e9088230.svg";